import {
  forwardRef,
  useState,
} from 'react'

import {
  Eye,
  EyeOff,
} from 'lucide-react'

import {
  Button,
} from './button'

import {
  TextField,
  type TextFieldProps,
} from './text-field'

export interface PasswordFieldProps
  extends Omit<
    TextFieldProps,
    'type' | 'trailingContent'
  > {
  showPasswordLabel?: string
  hidePasswordLabel?: string
}

export const PasswordField =
  forwardRef<
    HTMLInputElement,
    PasswordFieldProps
  >(function PasswordField(
    {
      showPasswordLabel =
        'Show password',
      hidePasswordLabel =
        'Hide password',
      isDisabled = false,
      ...textFieldProps
    },
    ref,
  ) {
    const [
      isPasswordVisible,
      setIsPasswordVisible,
    ] = useState(false)

    const toggleLabel =
      isPasswordVisible
        ? hidePasswordLabel
        : showPasswordLabel

    return (
      <TextField
        {...textFieldProps}
        ref={ref}
        isDisabled={isDisabled}
        type={
          isPasswordVisible
            ? 'text'
            : 'password'
        }
        spellcheck={false}
        trailingContent={
          <Button
            type="button"
            variant="ghost"
            size="small"
            isDisabled={isDisabled}
            aria-pressed={
              isPasswordVisible
            }
            aria-label={toggleLabel}
            className={[
              'h-8 w-8 shrink-0 p-0',
              'text-(--color-muted-foreground)',
              'hover:text-(--color-foreground)',
            ].join(' ')}
            onPress={() => {
              setIsPasswordVisible(
                (current) =>
                  !current,
              )
            }}
          >
            {isPasswordVisible ? (
              <EyeOff
                aria-hidden="true"
                className="h-4 w-4"
              />
            ) : (
              <Eye
                aria-hidden="true"
                className="h-4 w-4"
              />
            )}
          </Button>
        }
      />
    )
  })